<div class="d-flex flex-column flex-column-fluid">
  <div id="kt_app_content" class="app-content flex-column-fluid">
    <div id="kt_app_content_container" class="app-container container-fluid">
      <div class="row gx-5 gx-xl-10">
        <div class="card mb-5 mb-xxl-8">
          <p *ngIf="currentPath === 'detail'" class="fs-6 text px-5 pt-5 ps-5">
            {{ "profile.myProfile" | translate }}
          </p>
          <p *ngIf="currentPath === 'info'" class="fs-6 text px-5 pt-5 ps-5">
            {{ "profile.info" | translate }}
          </p>
          <img
            class="pt-5 pe-5 ps-5"
            src="assets/media/profile/line.svg"
            alt="image"
          />
          <div *ngIf="currentPath !== 'info'" class="card-body pt-9 pb-0">
            <div class="d-flex flex-wrap flex-sm-nowrap">
              <div class="me-7 mb-4">
                <div class="symbol symbol-160px symbol-fixed position-relative">
                  <input
                    type="file"
                    accept=".png, .jpeg, .jpg"
                    (change)="onFileSelected($event)"
                    style="display: none"
                    #fileInput
                  />

                  <img
                    [src]="previewImage || 'assets/media/profile/profile.svg'"
                    alt="image"
                    class="rounded-circle profile-photo-area"
                  />

                  <img
                    class="profile-edit-icon cursor-pointer"
                    src="assets/media/profile/picture-edit.svg"
                    alt="edit"
                    (click)="fileInput.click()"
                  />
                </div>
              </div>
              <div class="flex-grow-1">
                <div
                  class="d-flex justify-content-between align-items-start flex-wrap mb-2"
                >
                  <div class="d-flex flex-column">
                    <div class="d-flex align-items-center mb-2">
                      <a
                        class="text-gray-900 text-hover-primary fs-2 fw-bold me-1"
                        style="cursor: default"
                      >
                        {{ fullName || "" }}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="currentPath === 'info'" class="info-text p-6 pb-0">
            <div [innerHTML]="systemInformation?.information"></div>
          </div>
        </div>
        <div *ngIf="currentPath !== 'info'" class="card mb-5 mb-xxl-8">
          <!-- <p class="fs-6 text px-5 pt-4 ps-5">{{ title }}</p> -->
          <p class="fs-6 text px-5 pt-4 ps-5">
            {{ "profile.details" | translate }}
          </p>
          <img
            class="pt-5 ps-5 pe-5"
            src="assets/media/profile/line.svg"
            alt="image"
          />
          <!-- Tabs  -->
          <div class="card-body">
            <ul
              class="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6"
              role="tablist"
            >
              <li class="nav-item" role="presentation">
                <a
                  class="nav-link text-gray-800 active"
                  data-bs-toggle="tab"
                  href="#general"
                  aria-selected="true"
                  role="tab"
                  (click)="setTitle('general')"
                  >{{ "profile.general" | translate }}</a
                >
              </li>
              <li class="nav-item" role="presentation">
                <a
                  class="nav-link text-gray-800"
                  data-bs-toggle="tab"
                  href="#security"
                  aria-selected="true"
                  role="tab"
                  (click)="setTitle('security')"
                  >{{ "profile.security" | translate }}</a
                >
              </li>
              <li class="nav-item" role="presentation">
                <a
                  class="nav-link text-gray-800"
                  data-bs-toggle="tab"
                  href="#authentication"
                  aria-selected="true"
                  role="tab"
                  (click)="setTitle('authentication')"
                  >{{ "profile.authentication" | translate }}</a
                >
              </li>
            </ul>

            <div class="tab-content" id="myTabContent">
              <!-- General Tab Content -->
              <div
                class="tab-pane fade show active"
                id="general"
                role="tabpanel"
              >
                <form
                  [formGroup]="generalForm"
                  (ngSubmit)="save('generalForm')"
                >
                  <div class="col">
                    <div class="row g-4">
                      <!-- Name -->
                      <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                        <label for="inputName">{{ "name" | translate }}</label>
                        <div class="form-floating-profile">
                          <input
                            formControlName="name"
                            type="text"
                            class="form-control"
                            id="inputName"
                            [placeholder]="'name' | translate"
                            (input)="preventForbiddenCharacters($event, 'text')"
                          />
                          <div
                            *ngIf="isControlInvalid('name')"
                            class="text-danger"
                          >
                            <ng-container
                              *ngIf="
                                generalForm.get('name').hasError('required')
                              "
                            >
                              {{ "nameIsRequired" | translate }}
                            </ng-container>
                            <ng-container
                              *ngIf="
                                generalForm.get('name').hasError('pattern')
                              "
                            >
                              {{ "onlyLatinCharacters" | translate }}
                            </ng-container>
                          </div>
                        </div>
                      </div>
                      <!-- Surname -->
                      <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                        <label for="inputSurname">{{
                          "surname" | translate
                        }}</label>
                        <div class="form-floating-profile">
                          <input
                            formControlName="surname"
                            type="text"
                            class="form-control"
                            id="inputSurname"
                            [placeholder]="'surname' | translate"
                            (input)="preventForbiddenCharacters($event, 'text')"
                          />
                          <div
                            *ngIf="isControlInvalid('surname')"
                            class="text-danger"
                          >
                            <ng-container
                              *ngIf="
                                generalForm.get('surname').hasError('required')
                              "
                            >
                              {{ "surnameIsRequired" | translate }}
                            </ng-container>
                            <ng-container
                              *ngIf="
                                generalForm.get('surname').hasError('pattern')
                              "
                            >
                              {{ "onlyLatinCharacters" | translate }}
                            </ng-container>
                          </div>
                        </div>
                      </div>
                      <!-- Phone Number -->
                      <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                        <label for="inputTel">{{
                          "phoneNumber" | translate
                        }}</label>
                        <div class="form-floating-profile">
                          <input
                            formControlName="phoneNumber"
                            type="tel"
                            class="form-control"
                            id="inputTel"
                            [placeholder]="'phoneNumber' | translate"
                            maxlength="15"
                            (input)="preventForbiddenCharacters($event, 'tel')"
                          />
                          <div
                            *ngIf="isControlInvalid('phoneNumber')"
                            class="text-danger"
                          >
                            <div
                              *ngIf="generalForm.get('phoneNumber')?.errors?.['required']"
                            >
                              {{ "phoneNumberIsRequired" | translate }}
                            </div>
                            <div
                              *ngIf="generalForm.get('phoneNumber')?.errors?.['pattern']"
                            >
                              {{ "phoneNumberIsNotValid" | translate }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- Email -->
                      <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                        <label for="inputEmail">{{
                          "email" | translate
                        }}</label>
                        <div class="form-floating-profile">
                          <input
                            formControlName="email"
                            type="email"
                            class="form-control"
                            id="inputEmail"
                            [placeholder]="'email' | translate"
                          />
                          <div
                            *ngIf="isControlInvalid('email')"
                            class="text-danger"
                          >
                            <div
                              *ngIf="generalForm.get('email')?.errors?.['required']"
                            >
                              {{ "emailIsRequired" | translate }}
                            </div>
                            <div
                              *ngIf="generalForm.get('email')?.errors?.['email']"
                            >
                              {{ "emailIsNotValid" | translate }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- Language -->
                      <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                        <label for="inputLanguage">{{
                          "profile.language" | translate
                        }}</label>
                        <div class="form-floating-profile">
                          <select
                            formControlName="selectedLanguageCode"
                            class="form-select cursor-pointer"
                            id="inputLanguage"
                            aria-label="Language"
                          >
                            <option [ngValue]="null" disabled>
                              {{ "profile.language" | translate }}
                            </option>
                            <option
                              *ngFor="let lang of languages"
                              [value]="lang.code"
                            >
                              {{ lang.name | translate }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <!-- Mail Notification -->
                      <div
                        *ngIf="
                          currentUser?.role === userRole.GeneralPractitioner
                        "
                        class="col-lg-3 col-md-4 col-sm-6 mb-6"
                      >
                        <label for="inputMailNotification">{{
                          "profile.mailNotification" | translate
                        }}</label>
                        <div class="form-floating-profile">
                          <select
                            formControlName="mailNotification"
                            class="form-select cursor-pointer"
                            id="inputMailNotification"
                            aria-label="Mail Notification"
                            (change)="onMailNotificationChange($event)"
                          >
                            <option [ngValue]="null" disabled>
                              {{ "profile.select" | translate }}
                            </option>
                            <option
                              [value]="true"
                              [selected]="isEmailNotificationsEnabled"
                            >
                              {{ "yes" | translate }}
                            </option>
                            <option
                              [value]="false"
                              [selected]="!isEmailNotificationsEnabled"
                            >
                              {{ "no" | translate }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="d-flex justify-content-end mt-8 gap-3">
                        <button
                          type="submit"
                          [disabled]="!generalForm.valid"
                          class="btn btn-sm btn-primary cursor-pointer"
                        >
                          {{ "update" | translate }}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>

              </div>

              <!-- Security Tab Content -->
              <div class="tab-pane fade" id="security" role="tabpanel">
                <form
                  [formGroup]="securityForm"
                  (ngSubmit)="save('securityForm')"
                >
                  <div class="col">
                    <div class="row g-4">
                      <!-- Old Password -->
                      <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                        <label for="inputOldPassword">{{
                          "profile.oldPassword" | translate
                        }}</label>
                        <div class="input-group mb-3">
                          <span
                            class="input-group-text bg-white border border-end-0"
                          >
                            <img
                              src="assets/media/profile/lock.svg"
                              alt="Lock Icon"
                              class="img-fluid default-picture"
                            />
                          </span>
                          <div class="form-floating">
                            <input
                              [type]="oldPasswordVisible ? 'text' : 'password'"
                              formControlName="oldPassword"
                              class="form-control border border-start-0 border border-end-0 py-0 px-0"
                              id="inputOldPassword"
                            />
                          </div>
                          <span
                            class="input-group-text bg-white border border-start-0"
                            (click)="showPassword('oldPassword')"
                          >
                            <img
                              [src]="
                                oldPasswordVisible
                                  ? 'assets/media/profile/eye-slash.svg'
                                  : 'assets/media/profile/eye.svg'
                              "
                              alt="Lock Icon"
                              class="img-fluid default-picture"
                            />
                          </span>
                        </div>
                        <div
                          *ngIf="isResetPasswordControlInvalid('password')"
                          class="text-danger"
                        >
                          <div
                            *ngIf="securityForm.get('password')?.errors?.['required']"
                          >
                            {{ "alerts.oldPasswordRequired" | translate }}
                          </div>
                        </div>
                      </div>
                      <!-- Password -->
                      <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                        <label for="inputNewPassword">{{
                          "profile.password" | translate
                        }}</label>
                        <div class="input-group mb-3">
                          <span
                            class="input-group-text bg-white border border-end-0"
                          >
                            <img
                              src="assets/media/profile/lock.svg"
                              alt="Lock Icon"
                              class="img-fluid default-picture"
                            />
                          </span>
                          <div class="form-floating">
                            <input
                              formControlName="password"
                              class="form-control border border-start-0 border border-end-0 py-0 px-0"
                              id="inputNewPassword"
                              [type]="newPasswordVisible ? 'text' : 'password'"
                            />
                          </div>
                          <span
                            class="input-group-text bg-white border border-start-0"
                            (click)="showPassword('newPassword')"
                          >
                            <img
                              [src]="
                                newPasswordVisible
                                  ? 'assets/media/profile/eye-slash.svg'
                                  : 'assets/media/profile/eye.svg'
                              "
                              alt="Lock Icon"
                              class="img-fluid default-picture"
                            />
                          </span>
                        </div>
                        <div
                          *ngIf="isResetPasswordControlInvalid('password')"
                          class="text-danger"
                        >
                          <div
                            *ngIf="securityForm.get('password')?.errors?.['required']"
                          >
                            {{ "alerts.newPasswordRequired" | translate }}
                          </div>
                          <div
                            *ngIf="securityForm.get('password')?.errors?.['minlength']"
                          >
                            {{
                              "alerts.newPasswordMustBeAtLeast8Characters"
                                | translate
                            }}
                          </div>
                          <div
                            *ngIf="securityForm.get('password')?.errors?.['pattern']"
                          >
                            {{
                              "alerts.newPasswordMustContainAtLeastOneUppercaseLetterAndOneSpecialCharacter"
                                | translate
                            }}
                          </div>
                        </div>
                      </div>
                      <!-- Confirm Password -->
                      <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                        <label for="inputNewConfirmPassword">{{
                          "profile.confirmPassword" | translate
                        }}</label>
                        <div class="input-group mb-3">
                          <span
                            class="input-group-text bg-white border border-end-0"
                          >
                            <img
                              src="assets/media/profile/lock.svg"
                              alt="Lock Icon"
                              class="img-fluid default-picture"
                            />
                          </span>
                          <div class="form-floating">
                            <input
                              formControlName="confirmPassword"
                              class="form-control border border-start-0 border border-end-0 py-0 px-0"
                              id="inputNewConfirmPassword"
                              [type]="
                                confirmPasswordVisible ? 'text' : 'password'
                              "
                            />
                          </div>
                          <span
                            class="input-group-text bg-white border border-start-0"
                            (click)="showPassword('confirmPassword')"
                          >
                            <img
                              [src]="
                                confirmPasswordVisible
                                  ? 'assets/media/profile/eye-slash.svg'
                                  : 'assets/media/profile/eye.svg'
                              "
                              alt="Lock Icon"
                              class="img-fluid default-picture"
                            />
                          </span>
                        </div>
                        <div class="text-danger">
                          <div
                            *ngIf="securityForm.get('confirmPassword')?.errors?.['required']"
                          >
                            {{ "alerts.confirmPasswordRequired" | translate }}
                          </div>
                          <div
                            *ngIf="securityForm.get('confirmPassword')?.errors?.['minlength']"
                          >
                            {{
                              "alerts.confirmPasswordMustBeAtLeast8CharactersLong"
                                | translate
                            }}
                          </div>
                          <div
                            *ngIf="securityForm.get('confirmPassword')?.errors?.['pattern']"
                          >
                            {{
                              "alerts.confirmPasswordMustContainAtLeastOneUppercaseLetterAndOneSpecialCharacter"
                                | translate
                            }}
                          </div>
                          <div
                            *ngIf="securityForm.get('confirmPassword')?.errors?.['passwordMismatch']"
                          >
                            {{ "alerts.passwordsDoNotMatch" | translate }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex justify-content-end mt-8 gap-3">
                      <!-- <button
                          type="button"
                          class="btn btn-sm btn-secondary cursor-pointer"
                        >
                          {{ "cancel" | translate }}
                        </button> -->
                      <button
                        type="submit"
                        class="btn btn-sm btn-primary cursor-pointer"
                      >
                        {{ "update" | translate
                        }}<i class="ki-duotone ki-arrow-right fs-2x"></i>
                      </button>
                    </div>
                  </div>
                </form>

                <hr class="my-10" />

                <form [formGroup]="securityQuestionForm" (ngSubmit)="updateSecurityQuestion()">
                  <div class="row g-4">
                    <div class="col-12">
                      <h5>{{ "profile.question" | translate }}</h5>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                      <label for="securityQuestionCurrentPassword">{{ "profile.oldPassword" | translate }}</label>
                      <input id="securityQuestionCurrentPassword" type="password" formControlName="currentPassword" class="form-control" />
                      <div *ngIf="securityQuestionForm.get('currentPassword')?.invalid && securityQuestionForm.get('currentPassword')?.touched" class="text-danger">
                        {{ "alerts.oldPasswordRequired" | translate }}
                      </div>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                      <label for="securityQuestion">{{ "profile.question" | translate }}</label>
                      <select id="securityQuestion" formControlName="question" class="form-select">
                        <option [ngValue]="null" disabled>{{ "profile.question" | translate }}</option>
                        <option *ngFor="let question of securityQuestions" [value]="question">{{ question | translate }}</option>
                      </select>
                      <div *ngIf="securityQuestionForm.get('question')?.invalid && securityQuestionForm.get('question')?.touched" class="text-danger">
                        {{ "alerts.questionIsRequired" | translate }}
                      </div>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                      <label for="securityQuestionAnswer">{{ "profile.answer" | translate }}</label>
                      <input id="securityQuestionAnswer" type="text" formControlName="answer" class="form-control" />
                      <div *ngIf="securityQuestionForm.get('answer')?.invalid && securityQuestionForm.get('answer')?.touched" class="text-danger">
                        {{ "alerts.answerIsRequired" | translate }}
                      </div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-end mt-8 gap-3">
                    <button type="submit" class="btn btn-sm btn-primary cursor-pointer" [disabled]="securityQuestionForm.invalid">
                      {{ "update" | translate }}
                    </button>
                  </div>
                </form>
              </div>

              <!-- Authentication Tab Content -->
              <div class="tab-pane fade" id="authentication" role="tabpanel">
                <form [formGroup]="authForm">
                  <div class="col">
                    <div class="row g-4">
                      <!-- Google Authentication -->
                      <div class="form-check form-switch mt-6">
                        <input
                          formControlName="googleAuth"
                          class="form-check-input google-auth"
                          type="checkbox"
                          role="switch"
                          id="googleAuth"
                          (change)="onGoogleAuthToggle($event)"
                        />
                        <label class="form-check-label" for="googleAuth">
                          {{ "profile.googleAuthentication" | translate }}
                        </label>
                      </div>
                      <!-- Mail Authentication -->
                      <div class="form-check form-switch mt-6">
                        <input
                          formControlName="mailAuth"
                          class="form-check-input"
                          type="checkbox"
                          role="switch"
                          id="mailAuth"
                          data-bs-toggle="modal"
                          (change)="onMailAuthToggle($event)"
                          [attr.data-bs-target]="'#createMailCodeModal'"
                        />
                        <label class="form-check-label" for="googleAuth">{{
                          "profile.mailAuthentication" | translate
                        }}</label>
                      </div>
                    </div>
                    <!-- Mail Authentication Section -->
                    <form
                      *ngIf="showMailSection"
                      [formGroup]="mailCodeForm"
                      (submit)="submitMailAuthCode($event)"
                      class="form w-100"
                      novalidate="novalidate"
                      id="kt_sign_in_form"
                      data-kt-redirect-url="#"
                      action="#"
                    >
                      <div class="fw-semibold fs-4 mt-4">
                        {{ "profile.mailAuthentication" | translate }}
                      </div>
                      <div class="row">
                        <div class="col-md-3 mt-4">
                          <div class="form-floating">
                            <input
                              formControlName="code"
                              class="form-control"
                              id="inputCode"
                              type="text"
                              [placeholder]="'code' | translate"
                            />
                            <label for="inputCode">{{
                              "code" | translate
                            }}</label>
                            <div
                              *ngIf="isFirstLoginControlInvalid('code')"
                              class="text-danger"
                            >
                              <div
                                *ngIf="mailCodeForm.get('code')?.errors?.['required']"
                              >
                                {{ "codeIsRequired" | translate }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 mt-4">
                        <button
                          type="submit"
                          class="btn btn-primary cursor-pointer"
                          [disabled]="mailAuthSectionLoading"
                        >
                          <span class="indicator-label">
                            <ng-container
                              *ngIf="mailAuthSectionLoading; else showLoginText"
                            >
                              {{ "pleaseWait" | translate }}
                              <span
                                class="spinner-border spinner-border-sm align-middle ms-2"
                              ></span>
                            </ng-container>
                            <ng-template #showLoginText>
                              {{ "submit" | translate }}
                            </ng-template>
                          </span>
                        </button>
                      </div>
                    </form>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Create Qr Code Modal -->
<div
  class="modal fade"
  id="createGoogleQrCodeModal"
  tabindex="-1"
  aria-labelledby="createGoogleQrCodeModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-2" id="createGoogleQrCodeModalLabel">
          {{ "profile.qrCode" | translate }}
        </h1>
        <button
          type="button"
          class="btn-close cursor-pointer"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div
        class="modal-body fs-4 text-center"
        [ngClass]="{ 'pt-0': !isGoogleChecked }"
      >
        <div
          *ngIf="!googleQrCodeDetails?.qrCodeImageUrl; else showQrCode"
          class="spinner-border qr-code-spinner text-danger"
          role="status"
        >
          <span class="visually-hidden">{{ "loading" | translate }}...</span>
        </div>
        <ng-template #showQrCode>
          <img
            *ngIf="isGoogleChecked"
            [src]="googleQrCodeDetails.qrCodeImageUrl"
            class="w-100"
            alt="QR Code"
          />
          <form
            [formGroup]="googleQrCodeForm"
            (submit)="submitGoogleQrCodeForm($event)"
            class="form w-100"
            novalidate="novalidate"
            id="kt_sign_in_form"
            data-kt-redirect-url="#"
            action="#"
          >
            <div class="form-floating mt-4">
              <input
                formControlName="code"
                class="form-control"
                id="inputCode"
                type="text"
                [placeholder]="'code' | translate"
              />
              <label for="inputCode">{{ "code" | translate }}</label>
              <div
                *ngIf="isGoogleLoginControlInvalid('code')"
                class="text-danger"
              >
                <div *ngIf="googleQrCodeForm.get('code')?.errors?.['required']">
                  {{ "codeIsRequired" | translate }}
                </div>
              </div>
            </div>
            <div class="d-grid mb-10 mt-4">
              <button
                type="submit"
                class="btn btn-primary cursor-pointer"
                data-bs-dismiss="modal"
              >
                <span class="indicator-label">
                  {{ "submit" | translate }}
                </span>
              </button>
            </div>
          </form>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<!-- Mail Authentication Modal -->
<div
  class="modal fade"
  id="createGoogleQrCodeModal"
  tabindex="-1"
  aria-labelledby="createGoogleQrCodeModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-2" id="createGoogleQrCodeModalLabel">
          {{ "profile.qrCode" | translate }}
        </h1>
        <button
          type="button"
          class="btn-close cursor-pointer"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div
        class="modal-body fs-4 text-center"
        [ngClass]="{ 'pt-0': !isGoogleChecked }"
      >
        <div
          *ngIf="!googleQrCodeDetails?.qrCodeImageUrl; else showQrCode"
          class="spinner-border qr-code-spinner text-danger"
          role="status"
        >
          <span class="visually-hidden">{{ "loading" | translate }}...</span>
        </div>
        <ng-template #showQrCode>
          <img
            *ngIf="isGoogleChecked"
            [src]="googleQrCodeDetails.qrCodeImageUrl"
            class="w-100"
            alt="QR Code"
          />
          <form
            [formGroup]="googleQrCodeForm"
            (submit)="submitGoogleQrCodeForm($event)"
            class="form w-100"
            novalidate="novalidate"
            id="kt_sign_in_form"
            data-kt-redirect-url="#"
            action="#"
          >
            <div class="form-floating mt-4">
              <input
                formControlName="code"
                class="form-control"
                id="inputCode"
                type="text"
                [placeholder]="'code' | translate"
              />
              <label for="inputCode">{{ "code" | translate }}</label>
              <div
                *ngIf="isGoogleLoginControlInvalid('code')"
                class="text-danger"
              >
                <div *ngIf="googleQrCodeForm.get('code')?.errors?.['required']">
                  {{ "codeIsRequired" | translate }}
                </div>
              </div>
            </div>
            <div class="d-grid mb-10 mt-4">
              <button
                type="submit"
                class="btn btn-primary cursor-pointer"
                data-bs-dismiss="modal"
              >
                <span class="indicator-label">
                  {{ "submit" | translate }}
                </span>
              </button>
            </div>
          </form>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<!-- Mail Notification Modal -->
<div
  class="modal fade"
  id="mailNotificationModal"
  tabindex="-1"
  aria-labelledby="mailNotificationModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title fs-2" id="mailNotificationModalLabel">
          {{ "Mail Notification" | translate }}
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <form
        [formGroup]="mailNotificationForm"
        (ngSubmit)="onMailNotificationSubmit()"
      >
        <div class="modal-body">
          <label for="inputEmail">{{ "email" | translate }}</label>
          <div class="form-floating">
            <input
              formControlName="email"
              type="email"
              class="form-control"
              id="inputEmail"
              [placeholder]="'email' | translate"
              [appInputBlurDirective]="mailNotificationForm"
              (input)="preventForbiddenCharacters($event, 'email')"
            />
            <label for="inputEmail">*{{ "email" | translate }}</label>
            <div *ngIf="isControlInvalid('email')" class="text-danger">
              <div
                *ngIf="mailNotificationForm.get('email')?.errors?.['required']"
              >
                {{ "emailIsRequired" | translate }}
              </div>
              <div *ngIf="mailNotificationForm.get('email')?.errors?.['email']">
                {{ "emailIsNotValid" | translate }}
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-secondary cursor-pointer"
            data-bs-dismiss="modal"
          >
            {{ "Close" | translate }}
          </button>
          <button
            type="submit"
            class="btn btn-sm btn-dark cursor-pointer"
            [disabled]="!mailNotificationForm.value.email"
          >
            {{ "Save" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
